export default "__VITE_ASSET__VAQDWvfs__"